import routes from '@/constants/routes';
import { authCheck } from '@/features/authentication/api/auth';
import { useShowToast } from '@/hooks/useShowToast';
import { components } from '@/types/api';
import { AxiosError } from 'axios';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import { defaultApi } from 'src/api';
import i18n from 'i18next';
import React from 'react';

const useSamlValidate = () => {
  const [cookie, setCookie, removeCookie] = useCookies(['redirect', 'user', 'refreshToken']);
  const navigate = useNavigate();
  const { showToast } = useShowToast();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError, { token: string }>(async formData => {
    try {
      await defaultApi
        .post<{
          token: components['schemas']['Token'];
          user: components['schemas']['User'];
        }>('/saml2/validate-login', formData)
        .then(async response => {
          setCookie('user', response.data.token.accessToken, { path: '/' });
          setCookie('refreshToken', response.data.token.refreshToken, { path: '/' });
          await queryClient.invalidateQueries(authCheck.name);

          if (cookie.redirect) {
            removeCookie('redirect', { path: '/' });
            navigate(cookie.redirect);
          } else {
            navigate(routes.roadmaps);
          }
        });
    } catch (error) {
      showToast('error', t('authentication.login_error'));
      throw new Error(i18n.t('error', { message: error }));
    }
  });
};

export default useSamlValidate;
